import * as React from "react";
import type { AppTabListOverflowMenuItemState } from "./AppTabListOverflowMenu.types";
import { AppMenuItem } from "@1js/acui-menu";

export const renderAppTabListOverflowMenuItem = (
  state: AppTabListOverflowMenuItemState
) => {
  const {
    header,
    ignoreIsOverflowItemVisible,
    onClick,
    id,
    isVisible,
    root,
    keytipProps,
  } = state;

  if (!ignoreIsOverflowItemVisible && isVisible) {
    return null;
  }
  return (
    <AppMenuItem
      {...header}
      key={header.id}
      onClick={onClick}
      role={"menuitemradio"}
      id={id}
      className={root.className}
      title={""}
      keytipProps={keytipProps}
    >
      <div>{header.title}</div>
    </AppMenuItem>
  );
};
